var TESNAV = TESNAV || {};

// fire on document ready as this script might be called from <head>
jQuery(document).ready(function() {

  var avatarImage = function (element, imageUrl) {
    element.onerror = function() {
      element.src = TES.siteAssetsCDN + 'img/avatar_small.jpg';
    };
    element.src = imageUrl;
  };

  TESNAV.$container = jQuery('.new-header-wrapper .nav');

  if (!window || !window.location || !window.location.host) {
    return;
  }

  TESNAV.panelToggle();
  TESNAV.menuToggle();
  TESNAV.requestProfile();
  TESNAV.siteCountry();
  TESNAV.activityAlert();
});
